module.exports = __webpack_public_path__ + "img/member_coupons_icon.b3379333.png";